import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useHistory } from 'react-router-dom';

import Loading from './atoms/Loading';
import { useSession } from '../modules/session';
import { useQueryParams } from '../utils/queryParams';
import { saveSessionId } from '../utils/localStorage';

const SessionContainer = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const query = useQueryParams();
  const { s } = query;
  if (s) {
    saveSessionId(s);
  }

  const onError = () => history.push('/timeout');

  const session = useSession(location, onError);

  const childrenWithSession = cloneElement(children, { session });

  return session ? childrenWithSession : <Loading show={!session} hideProgressBar progressRate={0} />;
};

SessionContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SessionContainer;
